import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TLocation } from 'shared/types/location';

export const locationSlice = createSlice({
  name: 'location',
  initialState: {} as TLocation,
  reducers: {
    setLocation: (state, action: PayloadAction<TLocation | undefined>) => {
      return action.payload || state;
    },
  },
});

export const {
  reducer: locationReducer,
  name: locationReducerName,
  actions: { setLocation },
} = locationSlice;
